// userAction.js

export const setUserData = (userData) => ({
  type: 'SET_USER_DATA',
  payload: userData,
});
